import { GlobalService } from "@app/shared/services/global/global.service";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginService } from "@app/modules/auth/login/services/login.service";
import { Observable, of } from "rxjs";
import { tap, catchError, map } from "rxjs/operators";

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  constructor(private globalService: GlobalService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // We should not add access_token to login, register & refreshToken API's
    const urlToIgnore = /login/gi || /register/gi;

    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          if (
            evt.body.access_status == "expired" ||
            evt.body.access_status == "full_expired"
          ) {
            this.globalService.logout();
          }
        }
      }),

      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status == 0) {
            this.globalService.logout();
          }
        }
        return of(err);
      })
    );
  }
}
